<template>
  <v-app id="inspire">
    <v-overlay :value="isLoading" z-index="999999">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-overlay>
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <template v-for="(link, index) in links">
          <v-list-item
            link
            :key="link.title"
            v-if="!link.children || !link.children.length"
            :to="link.link"
            @click="listItemClick"
          >
            <v-list-item-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group
            v-else
            :key="link.title"
            :prepend-icon="link.icon"
            :value="link.expanded"
            @click="expandMenu(index)"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </template>

            <v-list-item
              v-for="(child, i) in link.children"
              :key="i.title"
              link
              style="padding-left: 30px"
              :to="child.link"
              @click="drawer = false"
            >
              <v-list-item-action>
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <v-list-item @click="logout" v-show="!!user">
          <v-list-item-action>
            <v-icon>mdi-arrow-collapse-left</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-container>
        <v-row>
          <v-col> </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="6" md="3" class="pt-9">
            <v-select
              v-show="this.$store.getters.isAuthenticated"
              :items="projects"
              :menu-props="{ maxHeight: '400' }"
              :label="activeProjectLabel"
              :value="activeProject.project_id"
              :item-text="(item) => item.name"
              :item-value="(item) => item.project_id"
              @change="updateActiveProject"
              persistent-hint
            >
            </v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <v-row align="center" justify="center">
          <router-view></router-view>
        </v-row>
      </v-container>
    </v-main>
    <v-dialog v-model="dialog" max-width="500px" :persistent="true">
      <!-- card start -->
      <v-card>
        <v-card-title>{{ transactionTitle }}</v-card-title>
        <v-card-text>
          <v-slider
            v-model="addTransactionScreenPosition"
            :tick-labels="addTransactionScreens"
            :max="isTransaction ? 3 : 4"
            step="1"
            ticks="always"
            :tick-size="isTransaction ? '4' : '5'"
          ></v-slider>
          <v-alert
            dense
            outlined
            type="error"
            v-for="error in errors"
            :key="error"
          >
            {{ error }}
          </v-alert>
          <!-- Type screen starts -->
          <v-row
            v-if="addTransactionScreenPosition === 0"
            align="center"
            justify="center"
          >
            <v-col cols="12" class="mx-auto">
              <div class="text-center">
                <v-btn
                  rounded
                  :outlined="isExpense"
                  class="ma-2"
                  text
                  color="red"
                  @click="expenseClick"
                  >Expense</v-btn
                >
                <v-btn
                  :outlined="isIncome"
                  rounded
                  class="ma-2"
                  text
                  color="green"
                  @click="incomeClick"
                  >Income</v-btn
                >
                <v-btn
                  :outlined="isTransaction"
                  rounded
                  class="ma-2"
                  text
                  color="primary"
                  @click="transferClick"
                  >Transfer</v-btn
                >
              </div>
            </v-col>
          </v-row>
          <!-- Type screen ends -->
          <!-- Form starts -->
          <v-form
            name="addTransactionForm"
            v-else-if="addTransactionScreenPosition > 0"
          >
            <!-- Period screen starts -->
            <div v-if="addTransactionScreenPosition === 1">
              <v-menu
                ref="transactionDate"
                v-model="transactionDate"
                :close-on-content-click="false"
                :return-value.sync="activeItem.date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="activeItem.date"
                    label="Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    aria-errormessage="date-error"
                    :aria-invalid="addTransactionValidationMessages.date"
                  >
                  </v-text-field>
                  <span id="date-error" class="errormessage">{{
                    addTransactionValidationMessages.date &&
                      addTransactionValidationMessages.date[0].message
                  }}</span>
                </template>
                <v-date-picker
                  v-model="activeItem.date"
                  @dblclick:date="$refs.transactionDate.save(activeItem.date)"
                  no-title
                  scrollable
                  @="$refs.transactionDate.save(activeItem.date)"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.transactionDate.save(activeItem.date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
              <v-menu
                ref="transactionPeriod"
                v-model="transactionPeriod"
                :close-on-content-click="false"
                :return-value.sync="activeItem.period"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="activeItem.period"
                    label="Period"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="activeItem.period"
                  type="month"
                  @dblclick:month="
                    $refs.transactionPeriod.save(activeItem.period)
                  "
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="transactionPeriod = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.transactionPeriod.save(activeItem.period)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <!-- Period screen ends -->
            <!-- Account screen starts -->
            <div v-else-if="addTransactionScreenPosition === 2">
              <p
                v-show="
                  isTransaction && activeAccounts && activeAccounts.length > 0
                "
                class="mb-0"
                style="border-bottom: 1px solid #c4c4c4"
              >
                From Account
              </p>
              <span id="from_account_id-error" class="errormessage">
                {{
                  addTransactionValidationMessages.from_account_id &&
                    addTransactionValidationMessages.from_account_id[0].message
                }}
              </span>
              <v-treeview
                :active.sync="selectedFromAccount"
                :open.sync="openFromAccount"
                v-show="activeAccounts && activeAccounts.length > 0"
                hoverable
                activatable
                :items="activeAccounts"
                item-disabled="disabled"
                selection-type="independent"
                @update:active="updateSelectedFromAccountOnSelect"
                aria-errormessage="from_account_id-error"
                :aria-invalid="addTransactionValidationMessages.from_account_id"
                open-on-click
                transition
              >
                <template slot="content" slot-scope="{ item }">
                  <a @click="updateSelectedAccount('from_account_id', item)">{{
                    item.name
                  }}</a>
                </template>
              </v-treeview>
              <p
                v-show="
                  isTransaction && activeAccounts && activeAccounts.length > 0
                "
                class="mb-0"
                style="border-bottom: 1px solid #c4c4c4"
              >
                To Account
              </p>
              <span id="from_account_id-error" class="errormessage">
                {{
                  addTransactionValidationMessages.to_account_id &&
                    addTransactionValidationMessages.to_account_id[0].message
                }}
              </span>
              <v-treeview
                :active.sync="selectedToAccount"
                :open.sync="openToAccount"
                v-show="
                  isTransaction && activeAccounts && activeAccounts.length > 0
                "
                hoverable
                activatable
                :items="activeAccounts"
                item-disabled="disabled"
                selection-type="independent"
                @update:active="updateSelectedToAccountOnSelect"
                open-on-click
                transition
                aria-errormessage="from_account_id-error"
                :aria-invalid="addTransactionValidationMessages.to_account_id"
              >
                <template slot="content" slot-scope="{ item }">
                  <a @click="updateSelectedAccount('to_account_id', item)">{{
                    item.name
                  }}</a>
                </template>
              </v-treeview>
              <p v-show="!activeAccounts || activeAccounts.length === 0">
                Please add an account to continue
              </p>
            </div>
            <!-- Account screen ends -->
            <!-- Category screen starts -->
            <div
              v-else-if="addTransactionScreenPosition === 3 && !isTransaction"
            >
              <span id="category-error" class="errormessage">
                {{
                  addTransactionValidationMessages.transaction_category_id &&
                    addTransactionValidationMessages.transaction_category_id[0]
                      .message
                }}
              </span>
              <v-treeview
                :active.sync="selectedCategory"
                :open.sync="openedCategory"
                v-show="!isTransaction && categories && categories.length > 0"
                hoverable
                activatable
                :items="categories"
                selection-type="independent"
                @update:active="updateSelectedCategoryOnSelect"
                open-on-click
                transition
                aria-errormessage="category-error"
                :aria-invalid="
                  addTransactionValidationMessages.transaction_category_id
                "
              >
                <template slot="content" slot-scope="{ item }">
                  <a @click="updateSelectedCategory(item)">{{ item.name }}</a>
                </template>
              </v-treeview>
              <p
                v-show="
                  (!categories || categories.length === 0) &&
                    (isExpense || isIncome)
                "
              >
                Please add a category for
                {{ isExpense ? "expenses" : isIncome ? "income" : "" }}
              </p>
            </div>
            <!-- Category screen ends -->
            <!-- Amount screen starts -->
            <div
              v-else-if="
                (isTransaction && addTransactionScreenPosition === 3) ||
                  addTransactionScreenPosition === 4
              "
            >
              <span id="amount-error" class="errormessage">
                {{
                  addTransactionValidationMessages.amount &&
                    addTransactionValidationMessages.amount[0].message
                }}
              </span>
              <v-text-field
                v-model="activeItem.amount"
                label="Amount"
                type="number"
              ></v-text-field>
              <span id="description-error" class="errormessage">
                {{
                  addTransactionValidationMessages.description &&
                    addTransactionValidationMessages.description[0].message
                }}
              </span>
              <v-textarea
                v-model="activeItem.description"
                label="Description"
                type="textarea"
              ></v-textarea>
            </div>
            <!-- Amount screen ends -->
          </v-form>
          <!-- Form ends -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Close</v-btn>
          <v-btn
            v-show="addTransactionHasNextScreen"
            color="primary"
            @click="addTransactionNextScreen"
            >Next</v-btn
          >
          <v-btn
            v-show="!addTransactionHasNextScreen"
            color="primary"
            @click="addTransaction"
            >{{ transactionActionBtn }}</v-btn
          >
        </v-card-actions>
      </v-card>
      <!-- card ends -->
    </v-dialog>
    <v-dialog
      v-if="this.$store.getters.isAuthenticated"
      :value="activeProjectDialog && !Object.keys(activeProject).length"
      width="500"
      :persistent="!Object.keys(activeProject).length"
    >
      <v-card>
        <v-card-title> Please select an active project </v-card-title>
        <v-divider />
        <v-card-text>
          <v-select
            v-show="this.$store.getters.isAuthenticated"
            :items="projects"
            :menu-props="{ maxHeight: '500' }"
            :label="activeProjectLabel"
            :value="activeProject.project_id"
            :item-text="(item) => item.name"
            :item-value="(item) => item.project_id"
            @change="updateActiveProject"
            persistent-hint
          >
          </v-select>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-footer color="success" padless>
      <v-row justify="center" no-gutters>
        <v-btn
          fab
          color="green accent-2"
          absolute
          top
          right
          @click="openDialog"
          v-show="!!user"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-col class="primary py-4 text-center white--text" cols="12">
          {{ new Date().getFullYear() }} — <strong>Teran</strong>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from "vuex";
const filterInactiveTreeview = (items, isTransaction) => {
  // Filter out undefined items first before processing
  return items
    .filter((item) => Boolean(item))
    .filter((item) => {
      // Determine if the item is transactable and does not have children
      const isTransactable =
        item.transactable === 1 &&
        (!item.children || item.children.length === 0);

      // If the item has children, filter them as well
      if (item.children && item.children.length > 0) {
        item.children = filterInactiveTreeview(item.children, isTransaction);
      }

      if (!isTransaction && item.is_liability) {
        return false;
      }
      // Keep the item if it's transactable or if it has children after filtering
      return isTransactable || (item.children && item.children.length > 0);
    });
};

export default {
  name: "App",
  components: {},
  data: () => ({
    transactionDate: false,
    transactionPeriod: false,
    drawer: false,
    currentDate: new Date().toISOString().substr(8, 2),
    errors: [],
    activeTransaction: null,
    addTransactionScreenPosition: 0,
    localValidationErrors: {},
    selectedToAccount: [],
    selectedFromAccount: [],
    openFromAccount: [],
    openToAccount: [],
    openedCategory: [],
    selectedCategory: [],
  }),
  methods: {
    setAddScreenPosition(position) {
      this.addTransactionScreenPosition = position;
    },
    addTransactionNextScreen() {
      const validation = this.validate(
        "addTransactionForm",
        this.localValidationErrors,
        this.setAddScreenPosition,
        this.addTransactionScreenPosition
      );
      if (Object.keys(validation).length === 0) {
        this.setAddScreenPosition(this.addTransactionScreenPosition + 1);
        // this.localValidationErrors = {...this.localValidationErrors, addTransactionForm: {}}
      }
      this.localValidationErrors = {
        ...this.localValidationErrors,
        addTransactionForm: validation,
      };
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.drawer = false;
        window.location.href = "/login";
      });
    },
    transferClick() {
      this.activeItem.type = "transfer";
    },
    incomeClick() {
      this.activeItem.type = "income";
    },
    expenseClick() {
      this.activeItem.type = "expense";
    },
    resetModel() {
      this.$store.dispatch("setActiveItem", {
        date: new Date().toISOString().substr(0, 10),
        period: new Date().toISOString().substr(0, 7),
        from_account_id: "",
        to_account_id: "",
        transaction_category_id: "",
        amount: "",
        description: "",
        type: "expense",
      });
      this.errors = [];
    },
    parseErrors(result) {
      var errors = result.response.data.errors;
      let keys = Object.keys(errors);
      this.errors = [];

      keys.forEach((key) => {
        let item = errors[key];
        item.forEach((error) => {
          this.errors.push(error);
        });
      });
    },
    addTransaction() {
      const validation = this.validate(
        "addTransactionForm",
        this.localValidationErrors,
        this.setAddScreenPosition
      );
      if (Object.keys(validation).length > 0) {
        // this.localValidationErrors = {...this.localValidationErrors, addTransactionForm: {}}
        this.localValidationErrors = {
          ...this.localValidationErrors,
          addTransactionForm: validation,
        };
        return;
      }
      var data = {
        date: this.activeItem.date,
        period: this.activeItem.period + "-" + this.currentDate,
        from_account_id: this.activeItem.from_account_id,
        transaction_category_id: this.activeItem.transaction_category_id,
        amount: this.activeItem.amount,
        description: this.activeItem.description || "",
      };
      if (this.isTransaction) {
        data = {
          to_account_id: this.activeItem.to_account_id,
          transaction_category_id: null,
          ...data,
        };
      }
      if (this.isEdit) {
        this.$store
          .dispatch("updateTransaction", {
            id: this.activeItem.id,
            data: data,
          })
          .then(() => {
            this.closeDialog();
            this.resetModel();
          })
          .catch((result) => {
            this.parseErrors(result);
          });
      } else {
        this.$store
          .dispatch("createTransaction", data)
          .then(() => {
            this.closeDialog();
            this.resetModel();
          })
          .catch((result) => {
            this.parseErrors(result);
          });
      }
    },
    openDialog() {
      this.$store.dispatch("setDialog", true);
    },
    closeDialog() {
      this.$store.dispatch("setIsEdit", false);
      this.$store.dispatch("setDialog", false);
      this.resetModel();
    },
    updateActiveProject(id) {
      this.$store.commit("SET_PROJECTS_DIALOG", false);
      this.$store.dispatch("setActiveProject", id);
    },
    updateSelectedCategory(item) {
      this.activeItem.transaction_category_id = item.id;
    },
    updateSelectedCategoryOnSelect(id) {
      this.activeItem.transaction_category_id = id[0];
    },
    updateSelectedFromAccountOnSelect(id) {
      if (!id.length) {
        this.activeItem["from_account_id"] = null;
        return;
      }
      this.activeItem["from_account_id"] = id[0];
    },
    updateSelectedToAccountOnSelect(id) {
      if (!id.length) {
        this.activeItem["to_account_id"] = null;
        return;
      }
      this.activeItem["to_account_id"] = id[0];
    },
    updateSelectedAccount(type, item) {
      this.activeItem[type] = item.id;
    },
    listItemClick() {
      this.drawer = false;
      this.$store.dispatch("removeExpansions");
    },
    expandMenu(index) {
      this.$store.dispatch("expandMenu", index);
    },
    extractChildCategories(category) {
      let children = [];
      Array.from(category.children).forEach((child) => {
        if (
          child.project_id === this.activeProject.project_id ||
          child.project_id === null
        ) {
          child.disabled = !child.transactable;
          children.push(child);
        }

        if (child.children) {
          this.extractChildCategories(child);
        }
      });

      if (
        category.project_id === this.activeProject.project_id ||
        category.project_id === null
      ) {
        category.children = children;
      }
    },
    validate(
      formName,
      errorsStore,
      setScreenPosition,
      currentScreenPosition = -1
    ) {
      const isNotEmpry = (value) => !!value;
      const isDate = (value) => !isNaN(new Date(value));
      const isNumber = (value) => !isNaN(parseFloat(value)) && isFinite(value);
      const isPositive = (value) => isNumber(value) && Number(value) > 0;
      const internalRules = {
        NOT_EMPTY: {
          condition: isNotEmpry,
          message: "Field should not be empty",
        },
        DATE: { condition: isDate, message: "Date is invalid" },
        NUMBER: {
          condition: isNumber,
          message: "Field should be numeric value",
        },
        POSITIVE: {
          condition: isPositive,
          message: "Value should be grater than 0",
        },
      };

      const validationRules = this.validationRules[formName];
      const validationErrors = {};
      validationRules.forEach((rule) => {
        const data = this.activeItem;
        const fieldValue = data[rule.fieldName];
        const isRuleArray = Array.isArray(rule.validationRule);
        if (isRuleArray) {
          rule.validationRule.forEach((externalRule) => {
            if (typeof externalRule === "string") {
              if (internalRules[externalRule]) {
                const isValid = internalRules[externalRule].condition(
                  fieldValue
                );
                if (
                  !isValid &&
                  (currentScreenPosition === -1 ||
                    rule.fieldScreen === currentScreenPosition)
                ) {
                  if (!validationErrors[rule.fieldName])
                    validationErrors[rule.fieldName] = [];
                  const error = {
                    message: internalRules[externalRule].message,
                    screenPosition: rule.fieldScreen,
                  };
                  validationErrors[rule.fieldName].push(error);
                }
              }
            } else if (typeof externalRule === "object") {
              const isValid = externalRule.condition(fieldValue);
              if (
                !isValid &&
                (currentScreenPosition === -1 ||
                  rule.fieldScreen === currentScreenPosition)
              ) {
                if (!validationErrors[rule.fieldName])
                  validationErrors[rule.fieldName] = [];
                const error = {
                  message: externalRule.message,
                  screenPosition: rule.fieldScreen,
                };
                validationErrors[rule.fieldName].push(error);
              }
            }
          });
        }
      });

      // errorsStore[formName] = validationErrors;

      // errorsStore = {...errorsStore, [formName]: validationErrors};
      this.setScreenPositionerByErrors(setScreenPosition, validationErrors);
      return validationErrors;
    },
    setScreenPositionerByErrors(setScreenPosition, validationErrors) {
      const validations = validationErrors
        ? Object.values(validationErrors)
        : [];
      if (validations.length > 0) {
        const firstElement = validations.sort(
          (a, b) => a.screenPosition - b.screenPosition
        )[0][0];
        setScreenPosition(firstElement.screenPosition);
      }
    },
  },
  async created() {
    if (this.$store.getters.isAuthenticated) {
      await this.$store.dispatch("loadProjects");
      this.$store.dispatch("loadAccounts");
      this.$store.dispatch("loadTransactionCategories");
      this.$store.dispatch("loadRecentUserAccounts");
      this.$store.dispatch("loadRecentUserTransactionCategories");
    }
  },
  computed: {
    ...mapGetters({
      links: "links",
      accounts: "accounts",
      transactionCategories: "transactionCategories",
      activeItem: "activeTransaction",
      dialog: "dialog",
      isEdit: "isEdit",
      projects: "projects",
      activeProjectDialog: "activeProjectDialog",
      transactionTreeViewCategories: "transactionTreeViewCategories",
      activeProject: "activeProject",
      recentUserAccounts: "recentUserAccounts",
      recentUserTransactionCategories: "recentUserTransactionCategories",
    }),
    ...mapState({
      user: (state) => state.auth.user,
      isLoading: (state) => state.isLoading,
    }),
    validationRules() {
      return {
        addTransactionForm: [
          {
            fieldName: "date",
            validationRule: ["NOT_EMPTY", "DATE"],
            fieldScreen: 1,
          },
          {
            fieldName: "period",
            validationRule: ["NOT_EMPTY", "DATE"],
            fieldScreen: 1,
          },
          {
            fieldName: "from_account_id",
            validationRule: ["NOT_EMPTY"],
            fieldScreen: 2,
          },
          {
            fieldName: "to_account_id",
            validationRule: this.isTransaction ? ["NOT_EMPTY"] : [],
            fieldScreen: 2,
          },

          {
            fieldName: "transaction_category_id",
            validationRule: this.isTransaction ? [] : ["NOT_EMPTY"],
            fieldScreen: 3,
          },
          {
            fieldName: "amount",
            validationRule: ["NUMBER", "POSITIVE"],
            fieldScreen: this.isTransaction ? 3 : 4,
          },
          {
            fieldName: "description",
            validationRule: ["NOT_EMPTY"],
            fieldScreen: this.isTransaction ? 3 : 4,
          },
        ],
      };
    },
    addTransactionValidationMessages() {
      return this.localValidationErrors.addTransactionForm || {};
    },
    addTransactionScreens() {
      if (this.isTransaction) return ["Type", "Period", "Account", "Amount"];
      return ["Type", "Period", "Account", "Category", "Amount"];
    },
    activeProjectLabel() {
      if (this.$store.getters.isAuthenticated) {
        return "Active project (" + this.user.email + ")";
      }
      return "Active project";
    },
    addTransactionHasNextScreen() {
      return (
        this.addTransactionScreens.length - 1 !==
        this.addTransactionScreenPosition
      );
    },
    activeAccounts() {
      // Reset form when dialog closed
      if (!this.dialog) return [];

      let accounts = JSON.parse(JSON.stringify(this.accounts));

      const flattenAccounts = (items) => {
        let result = [];
        items.forEach((item) => {
          result.push(item);
          if (item.children) {
            result = result.concat(flattenAccounts(item.children));
          }
        });

        return result;
      };

      let recent = {
        id: "recent",
        name: "Recent",
        disabled: true,
        children: JSON.parse(JSON.stringify(this.recentUserAccounts)).map((i) =>
          flattenAccounts(accounts).find((j) => j.id == i.account_id)
        ),
      };

      if (recent.children.length != 0) {
        accounts = [recent, ...accounts];
      }

      if (accounts) {
        const currentAccounts = accounts.filter(
          (account) =>
            account.id == "recent" ||
            (!account.parent_id &&
              account.project_id === this.activeProject.project_id)
        );

        return filterInactiveTreeview(currentAccounts, this.isTransaction);
      }

      return [];
    },
    categories() {
      // Reset form when dialog closed
      if (!this.dialog) return [];

      var copy = JSON.parse(JSON.stringify(this.transactionTreeViewCategories));

      const flattenCopy = (copy) => {
        let result = [];
        copy.forEach((item) => {
          result.push(item);
          if (item.children) {
            result = result.concat(flattenCopy(item.children));
          }
        });

        return result;
      };

      const recent = {
        id: "recent",
        name: "Recent",
        children: JSON.parse(
          JSON.stringify(this.recentUserTransactionCategories)
        ).map((i) =>
          flattenCopy(copy).find((j) => i.transaction_category_id == j.id)
        ),
      };

      recent.children = recent.children.filter((category) => {
        if (
          category.project_id === this.activeProject.project_id ||
          (category.project_id === null &&
            category.project_type === this.activeProject.type)
        ) {
          if (category.type === (this.isExpense ? "expense" : "income")) {
            return true;
          }
        }

        return false;
      });

      if (recent.children.length != 0) {
        copy = [recent, ...copy];
      }

      copy = copy.filter((category) => {
        this.extractChildCategories(category);

        if (category.id == "recent") {
          return true;
        }

        if (
          category.project_id === this.activeProject.project_id ||
          (category.project_id === null &&
            category.project_type === this.activeProject.type)
        ) {
          if (category.type === (this.isExpense ? "expense" : "income")) {
            return true;
          }
        }

        return false;
      });

      //we need to convert the is_main property as vuetify treeview expects a boolean, the one we have is integer
      //also we need a custom disable property for the treeview as we cannot variable in the prop
      const categoriesMap = copy.map((category) => {
        category.is_main = !!category.is_main;
        category.activatable = category.transactable;
        return category;
      });
      return filterInactiveTreeview(categoriesMap);
    },
    fromAccountLabel() {
      if (this.isIncome) {
        return "To account";
      }
      return "From account";
    },
    transactionTitle() {
      if (!this.isEdit) {
        return "Add new transaction";
      }
      return "Edit transaction";
    },
    transactionActionBtn() {
      if (!this.isEdit) {
        return "Add";
      }
      return "Update";
    },
    isTransaction() {
      return this.activeItem.type === "transfer";
    },
    isIncome() {
      return this.activeItem.type === "income";
    },
    isExpense() {
      return this.activeItem.type === "expense";
    },
  },
};
</script>
<style>
.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 20px !important;
}
.errormessage {
  color: red;
  font-weight: 400;
}
</style>
